import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';

import {
  TGetModerationComplainMicrofrontendModel,
  IGetModerationComplainMicrofrontendRequest,
  TGetModerationComplainMicrofrontendResponse,
  IMappers,
} from './types';

const defaultConfig: TGetModerationComplainMicrofrontendModel = {
  apiType: 'public',
  assertStatusCodes: [200],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'moderation-complain-frontend',
  pathApi: '/v1/get-moderation-complain-microfrontend/',
} as TGetModerationComplainMicrofrontendModel;

function createGetModerationComplainMicrofrontendModel(
  parameters: IGetModerationComplainMicrofrontendRequest,
): TGetModerationComplainMicrofrontendModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetModerationComplainMicrofrontendOptions<TResponse200> {
  httpApi: IHttpApi;
  parameters: IGetModerationComplainMicrofrontendRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200>;
}

async function fetchGetModerationComplainMicrofrontend<TResponse200>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetModerationComplainMicrofrontendOptions<TResponse200>): Promise<
  TResponse200 | TGetModerationComplainMicrofrontendResponse
> {
  const { response, statusCode, headers } = await httpApi.fetch(
    createGetModerationComplainMicrofrontendModel(parameters),
    config,
  );

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response);
    }
  }

  return { response, statusCode, headers } as TGetModerationComplainMicrofrontendResponse;
}

export { defaultConfig, createGetModerationComplainMicrofrontendModel, fetchGetModerationComplainMicrofrontend };
